export default __webpack_public_path__ + "static/media/readme.25a44794.txt";